import React from 'react'
import { Link } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link'
import { RiInstagramFill, RiFacebookFill, RiTwitterFill, RiYoutubeFill, RiMailFill, RiPhoneFill } from 'react-icons/ri'

//images
import brandimg from '../assets/brandlogo.png'

const Footer = () => {
  return (
    <footer className="bg-white border-t mt-12">
      <div className="container mx-auto px-6 py-10 lg:flex lg:justify-between">
        {/* Brand & Description */}
        <div className="lg:w-1/3 mb-6 pr-4">
  <Link to="/" aria-label="Go home" title="Company" className="inline-flex items-center">
    <img className="h-8 w-auto" src={brandimg} alt="brand logo" />
  </Link>
  <p className="mt-2 text-gray-600 text-sm max-w-sm leading-snug">
    Welcome to Globalpro International Education Consultancy, your trusted partner in the journey towards higher education in the world's top universities.
  </p>
</div>


        {/* Links & Contact */}
        <div className="lg:w-2/3 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Category */}
          <div>
            <h3 className="text-gray-800 font-semibold mb-4">Category</h3>
            <ul className="space-y-2 text-gray-600 text-sm">
              <li><Link to="/about" className="hover:text-gray-800">Company</Link></li>
              <li><Link to="/privacy" className="hover:text-gray-800">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-gray-800">Terms & Conditions</Link></li>
              <li><Link to="/faq" className="hover:text-gray-800">FAQ</Link></li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-gray-800 font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-gray-600 text-sm">
              <li><HashLink smooth to="/programs#testimonials" className="hover:text-gray-800">Testimonials</HashLink></li>
              <li><Link to="/blogs" className="hover:text-gray-800">Blogs</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-gray-800 font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3 text-gray-600 text-sm">
              <li className="flex items-center">
                <RiMailFill className="mr-2 text-xl" />
                <a href="mailto:admin@globalprointernational.com" className="hover:text-gray-800">admin@globalprointernational.com</a>
              </li>
              {/* <li className="flex items-center">
                <RiMailFill className="mr-2 text-xl" />
                <a href="mailto:email2@example.com" className="hover:text-gray-800">email2@example.com</a>
              </li> */}
              <li className="flex items-center">
                <RiPhoneFill className="mr-2 text-xl" />
                <a href="tel:+918983290551" className="hover:text-gray-800">+91 8983290551</a>
              </li>
              {/* <li className="flex items-center">
                <RiPhoneFill className="mr-2 text-xl" />
                <a href="tel:+15557654321" className="hover:text-gray-800">+1 (555) 765-4321</a>
              </li> */}
            </ul>
          </div>
        </div>
      </div>

      <div className="bg-gray-100 py-4">
        <div className="container mx-auto px-6 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-gray-600 text-sm">© Copyright 2026 Globalpro. All rights reserved.</p>
          <div className="flex mt-4 sm:mt-0 space-x-4 text-gray-500 text-2xl">
            <a href="/" aria-label="Facebook" className="hover:text-[#3b5998]"><RiFacebookFill /></a>
            <a href="/" aria-label="Twitter" className="hover:text-[#26a7de]"><RiTwitterFill /></a>
            <a href="/" aria-label="Instagram" className="hover:text-[#e2457a]"><RiInstagramFill /></a>
            <a href="/" aria-label="YouTube" className="hover:text-[#CD201F]"><RiYoutubeFill /></a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
